
import { LANGUAGES } from './languages';
import messages_de from "./de.json";
import messages_en from "./en.json";
import messages_it from "./it.json";
import messages_es from "./es.json";
import messages_fr from "./fr.json";

export const messages = {
  [LANGUAGES.IT]: messages_it,
  [LANGUAGES.DE]: messages_de,
  [LANGUAGES.ES]: messages_es,
  [LANGUAGES.FR]: messages_fr,
  [LANGUAGES.EN]: messages_en,
};
